const getImage = (filename) => {
  return require(`../img/newProducts/${filename}`);
};

export const newProducts = [
    {
        id: "gen-00000001",
        brand: "Genrod",
        category: "Caños",
        description: "Caño de PVC doblado en frío de 20mm (3/4'') - Línea NERA - Genrod",
        image: getImage("GEN-00000001.jpg")
    },
        {
        id: "gen-00000002",
        brand: "Genrod",
        category: "Accesorios para caños",
        description: "Curva de PVC de 20mm (3/4'') - Línea NERA - Genrod",
        image: getImage("GEN-00000002.jpg")
    },
        {
        id: "gen-00000003",
        brand: "Genrod",
        category: "Accesorios para caños",
        description: "Conector de PVC de 20mm (3/4'') - Línea NERA - Genrod",
        image: getImage("GEN-00000003.jpg")
    },
        {
        id: "gen-00000004",
        brand: "Genrod",
        category: "Accesorios para caños",
        description: "Unión de PVC de 20mm (3/4'') - Línea NERA - Genrod",
        image: getImage("GEN-00000004.jpg")
    },
        {
        id: "gen-00000005",
        brand: "Genrod",
        category: "Accesorios para caños",
        description: "Grampa de PVC de 20mm (3/4'') - Línea NERA - Genrod",
        image: getImage("GEN-00000005.jpg")
    },
        {
        id: "gen-00000006",
        brand: "Genrod",
        category: "Cajas y Gabinetes",
        description: "Caja exterior rectangular Monoblock - Línea NERA - Genrod",
        image: getImage("GEN-00000006.jpg")
    },
        {
        id: "gen-00000007",
        brand: "Genrod",
        category: "Cajas y Gabinetes",
        description: "Caja exterior cuadrada con tapa - Línea NERA - Genrod",
        image: getImage("GEN-00000007.jpg")
    },
        {
        id: "gen-00000008",
        brand: "Genrod",
        category: "Cajas y Gabinetes",
        description: "Caja exterior octogonal con tapa - Línea NERA - Genrod",
        image: getImage("GEN-00000008.jpg")
    },
        {
        id: "gen-00000009",
        brand: "Genrod",
        category: "Cajas y Gabinetes",
        description: "Caja de pase IP65 - Medidas: 90x90x75mm y 115x115x80mm - Línea NERA - Genrod",
        image: getImage("GEN-00000009.jpg")
    },
        {
        id: "gen-00000010",
        brand: "Genrod",
        category: "Cajas y Gabinetes",
        description: "Gabinete exterior de PCV con tapa fumé - Disponible para 4, 8 y 12 bocas - Línea NERA - Genrod",
        image: getImage("GEN-00000010.jpg")
    },
    {
        id: "baw-00000001",
        brand: "Baw",
        category: "Instrumentos de medición",
        description: "Multimedidor monofásico con registro de kWh - Modelo MM1D5-45 - Baw",
        image: getImage("BAW-00000001.jpg")
    },
    {
        id: "baw-00000002",
        brand: "Baw",
        category: "Instrumentos de medición",
        description: "Multímetro digital manual - Modelo BAWM02 - Baw",
        image: getImage("BAW-00000002.jpg")
    },
    {
        id: "baw-00000003",
        brand: "Baw",
        category: "Protectores",
        description: "Protección digital de tensión y corriente monofásica - Modelo PVA-63AP - Baw",
        image: getImage("BAW-00000003.jpg")
    },
    {
        id: "baw-00000004",
        brand: "Baw",
        category: "Protectores",
        description: "Protección y control SMART WiFi de instalación eléctrica monofásica - Modelo PVA-63AP1 - Baw",
        image: getImage("BAW-00000004.jpg")
    },
    {
        id: "baw-00000005",
        brand: "Baw",
        category: "Protectores",
        description: "Selector automático de fase con medición y protección de tensión y corriente - Modelo RU400F80 - Baw",
        image: getImage("BAW-00000005.jpg")
    },
    {
        id: "baw-00000006",
        brand: "Baw",
        category: "Interruptores",
        description: "Interruptor inteligente WIFI, en un módulo DIN - Modelo TELE161M-P - Baw",
        image: getImage("BAW-00000006.jpg")
    },
    {
        id: "baw-00000007",
        brand: "Baw",
        category: "Seguridad",
        description: "Extintor para tablero - Modelo 1M - Baw",
        image: getImage("BAW-00000007.jpg")
    },
    {
        id: "cle-00000001",
        brand: "Cleos",
        category: "Iluminación",
        description: "Cinta flexible LED IP65 exterior 12v - Modelo F30-12V65 - Cleos",
        image: getImage("CLE-00000001.jpg")
    },
    {
        id: "cle-00000002",
        brand: "Cleos",
        category: "Detectores",
        description: "Sensor de humo IP20 - Modelo CL-85 - Cleos",
        image: getImage("CLE-00000002.jpg")
    },
    {
        id: "cle-00000003",
        brand: "Cleos",
        category: "Porteros y timbres",
        description: "Timbre inalámbrico kinetic - Modelo CL-ZERO - Cleos",
        image: getImage("CLE-00000003.jpg")
    },
    {
        id: "com-00000001",
        brand: "Commax",
        category: "Porteros y timbres",
        description: "Kit portero eléctrico - Modelo DP-201LA - Commax",
        image: getImage("COM-00000001.jpg")
    },
    {
        id: "day-00000001",
        brand: "Zurich",
        category: "Interruptores",
        description: "Temporizador mecánico programable enchufable - Modelo XTIM03203 - Zurich",
        image: getImage("DAY-00000001.jpg")
    },
    {
        id: "lig-00000001",
        brand: "Light Tronic",
        category: "Extractores",
        description: "Extractor de 4'' - Modelo B04 - Light Tronic",
        image: getImage("LIG-00000001.jpg")
    },
    {
        id: "sas-00000001",
        brand: "TBCin",
        category: "Detectores",
        description: "Detector de monóxido de carbono a pila (AA) - Modelo ST82 - TBCin",
        image: getImage("SAS-00000001.jpg")
    },
    {
        id: "sas-00000002",
        brand: "TBCin",
        category: "Herramientas",
        description: "Punta de prueba 3 en 1 - Modelo 6890-62 3 - TBCin",
        image: getImage("SAS-00000002.jpg")
    },
    {
        id: "sas-00000003",
        brand: "TBCin",
        category: "Iluminación",
        description: "Lámpara LED bulbo RGB con control remoto - A60-SMD-3P - TBCin",
        image: getImage("SAS-00000003.jpg")
    },
    {
        id: "vef-00000001",
        brand: "Vefben",
        category: "Señalización",
        description: "Voltímetro digital enchufable - Modelo VE-01 - Vefben",
        image: getImage("VEF-00000001.jpg")
    },
];

